var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"autoplay":true}},_vm._l((_vm.carousel),function(item){return _c('el-carousel-item',{key:item},[_c('el-image',{attrs:{"src":item,"fit":"cover"}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }